import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export const mockBackendInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  // Mock endpoint for exchange rate: /api/dashboard/exchange-rates/
  if (req.url.includes('dashboard/exchange-rates')) {
    const from = (req.params.get('from') || 'EUR').toUpperCase().replace('C', '');
    const to = (req.params.get('to') || 'USD').toUpperCase().replace('C', '');

    let rate = 1.0;
    if (from === 'EUR' && to === 'USD') {
      rate = 1.085;
    } else if (from === 'USD' && to === 'EUR') {
      rate = 0.9216;
    }

    const mockBody = {
      from_currency: from,
      to_currency: to,
      rate,
      timestamp: new Date().toISOString(),
    };

    return of(
      new HttpResponse({
        status: 200,
        statusText: 'OK',
        body: mockBody,
      }),
    ).pipe(delay(200));
  }

  return next(req);
};
